import { APIVersion, axios } from "../../Config/config.js";
const sharedBaseUrl = "https://shared.dev.silal.app";
// axios.defaults.baseURL = basePath;

// const getRequests = async (payload) => {
//   return await axios.get(
//     `${APIVersion}requests/?page=1&per_page=2000`,
//     payload
//   );
// };
const getShifts = async () => {
  let url = "delivery/1/last_mile_shifts/";

  return await axios.get(`${APIVersion}${url}`);
};

const createShifts = async (payload) => {
  let url = "delivery/1/last_mile_shifts/";

  return await axios.post(`${APIVersion}${url}`, payload);
};

const updateShifts = async (payload) => {
  let url = `delivery/1/last_mile_shifts/${payload.id}/`;

  return await axios.put(`${APIVersion}${url}`, payload);
};

const unRegisterShift = async (payload) => {
  let url = `delivery/1/last_mile_shifts/${payload.shiftId}/unregister_carrier/${payload.carrierId}/`;
  return await axios.delete(`${APIVersion}${url}`);
};

const add_city = async (payload) => {
  let url = `cities/`;
  return await axios.post(`${APIVersion}${url}`, payload);
};

const get_cities = async (payload) => {
  let url = `region/${payload.regionId}/cities?page=1&per_page=2000`;
  return await axios.get(`${APIVersion}${url}`);
};

const update_city = async (payload) => {
  let url = `cities/${payload.city_id}`;
  return await axios.put(`${APIVersion}${url}`, payload);
};

const delete_city = async (payload) => {
  let url = `cities/${payload.city_id}`;
  return await axios.delete(`${APIVersion}${url}`);
};

const add_town = async (payload) => {
  let url = `towns/`;
  return await axios.post(`${APIVersion}${url}`, payload);
};

const get_towns = async (payload) => {
  let url = `city/${payload.cityId}/towns?page=1&per_page=2000`;
  return await axios.get(`${APIVersion}${url}`);
};

const update_town = async (payload) => {
  let url = `towns/${payload.town_id}`;
  return await axios.put(`${APIVersion}${url}`, payload);
};

const delete_town = async (payload) => {
  let url = `towns/${payload.town_id}`;
  return await axios.delete(`${APIVersion}${url}`);
};

export {
  getShifts,
  createShifts,
  updateShifts,
  unRegisterShift,
  get_cities,
  update_city,
  delete_city,
  get_towns,
  update_town,
  delete_town,
  add_city,
  add_town,
};
